import React from 'react';

const AboutUs = () => {
    const values = [
        {
            title: "Innovación",
            description: "Mejoramos constantemente la experiencia digital de negocios de servicios.",
            icon: (
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                </svg>
            ),
            color: "primary"
        },
        {
            title: "Colaboración",
            description: "Trabajamos junto a nuestros clientes para crear soluciones a medida.",
            icon: (
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
            ),
            color: "secondary"
        },
        {
            title: "Confianza",
            description: "Construimos relaciones duraderas basadas en transparencia e integridad.",
            icon: (
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
            ),
            color: "primary"
        }
    ];

    return (
        <section id="nosotros" className="py-24 relative overflow-hidden bg-gray-50">
            {/* Background decoration */}
            <div className="absolute top-0 left-0 w-full h-32 bg-white transform -skew-y-2 origin-top-left"></div>
            <div className="absolute bottom-0 left-0 w-full h-32 bg-white transform skew-y-2 origin-bottom-left"></div>

            {/* Subtle decorative elements */}
            <div className="absolute top-1/4 right-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-1/4 left-10 w-72 h-72 bg-secondary/5 rounded-full blur-3xl"></div>

            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-5xl font-bold mb-6 mt-2 text-secondary">
                        Sobre Nosotros
                    </h2>

                    <p className="text-xl text-gray-600 mb-8">
                        Fundados en 2024, transformamos la gestión de negocios de servicios con soluciones digitales intuitivas
                    </p>

                    <div className="bg-white rounded-xl shadow-md p-6 mb-16">
                        <p className="text-gray-700 leading-relaxed">
                            En Grovi, desarrollamos herramientas digitales potentes pero sencillas para que spas, barberías, clínicas y centros de bienestar optimicen sus operaciones y mejoren la experiencia de sus clientes. Nuestra misión es simplificar la gestión de citas y mejorar la presencia online de pequeños y medianos negocios.
                        </p>
                    </div>
                </div>

                {/* Values section - compact version */}
                <div className="grid md:grid-cols-3 gap-6">
                    {values.map((value, index) => (
                        <div key={index} className="value-card bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl flex flex-col items-center text-center">
                            <div className={`w-14 h-14 rounded-full bg-${value.color} flex items-center justify-center mb-4`}>
                                {value.icon}
                            </div>
                            <h4 className="text-lg font-bold text-secondary mb-2">{value.title}</h4>
                            <p className="text-gray-600 text-sm">{value.description}</p>
                        </div>
                    ))}
                </div>

                {/* Vision - simplified */}
                <div className="bg-secondary rounded-xl p-6 text-center text-white mt-16 mb-8">
                    <h3 className="text-xl font-bold mb-3">Nuestra Visión</h3>
                    <p className="text-lg font-light max-w-3xl mx-auto">
                        "Simplificar la gestión digital para que cada negocio de servicios pueda ofrecer una experiencia excepcional a sus clientes."
                    </p>
                </div>

                {/* CTA */}
                <div className="text-center">
                    <a href="#contacto" className="inline-flex items-center px-5 py-2.5 bg-primary text-white font-medium rounded-lg transition-all duration-300 hover:bg-primary-dark shadow-md">
                        Conozcámonos
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </a>
                </div>
            </div>

            {/* Animation styles */}
            <style jsx="true">{`
                .value-card {
                    opacity: 0;
                    animation: fadeInUp 0.8s ease-out forwards;
                }
                
                .value-card:nth-child(1) { animation-delay: 0.2s; }
                .value-card:nth-child(2) { animation-delay: 0.4s; }
                .value-card:nth-child(3) { animation-delay: 0.6s; }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
            `}</style>
        </section>
    );
};

export default AboutUs; 